











import {Component, Vue, Prop} from 'vue-property-decorator'
import {BulkOverride, DistanceOverride, Rate, TimeOverride} from '@/lib/kepler/interfaces'

import TimeOverrides from '../../TimeOverrides.vue'
import DistanceOverrides from '../../DistanceOverrides.vue'
import BulkOverrides from '../../BulkOverrides.vue'
import PlanBaseRate from '../../subscriptions/PlanBaseRate.vue'
import Layout from '@/components/proxy/Layout.vue'
import Chip from '@/components/proxy/Chip.vue'
import Divider from '@/components/proxy/Divider.vue'

type OverrideArray = TimeOverride[] | BulkOverride[] | DistanceOverride[] | []
type Override = TimeOverride | BulkOverride | DistanceOverride

@Component({
  name: 'VehicleFares',
  components: {Divider, Chip, Layout, PlanBaseRate, BulkOverrides, DistanceOverrides, TimeOverrides},
})
export default class VehicleFares extends Vue {
  @Prop() public baseRate!: Rate

  public get overrides() {
    const types = ['time', 'distance', 'bulk']
    const result: { [type: string]: any } = {}
    types.forEach((type) => {
        const typeOverrides: OverrideArray = this.baseRate[type + '_overrides']
        const overrides = typeOverrides.map((a: Override) => ({...a})) // clone array
        if (!!overrides?.length) {

          // shitfix for hardcoded ids
          let incremental = 0
          overrides.forEach((override) => {
            override.id += incremental
            incremental++
          })
          // end shitfix

          result[type] = overrides
        }
      },
    )
    return result
  }
}
